var map = {
	"./360.png": "nT0t",
	"./A-TFapple.png": "kQuw",
	"./A-android.png": "gsN1",
	"./A-apple.png": "VkKt",
	"./AMac.png": "I7eI",
	"./Awindows.png": "ZBT9",
	"./FoundWinners.jpg": "TJ1D",
	"./HK-Android.png": "h1IS",
	"./HK-TF.png": "+ywu",
	"./HK-apple.png": "+tiW",
	"./atpz.jpeg": "mVi0",
	"./aypz.jpeg": "Qm8d",
	"./azpz.jpeg": "8oUc",
	"./banner.png": "P07D",
	"./banner1.png": "CMrX",
	"./banner_activity.png": "HCZX",
	"./bdxy.png": "ovYA",
	"./bg.png": "yRcn",
	"./bg_01.jpg": "V3Wx",
	"./bg_01.png": "Ydyk",
	"./buy@2x.png": "f6zM",
	"./capital_meter.png": "Q/BT",
	"./chat_files/def.png": "Zrk4",
	"./chat_files/doc.png": "wz33",
	"./chat_files/gif.png": "wkSy",
	"./chat_files/html.png": "2OdG",
	"./chat_files/jpeg.png": "Krat",
	"./chat_files/mp3.png": "uHHb",
	"./chat_files/pdf.png": "9Z7U",
	"./chat_files/png.png": "16vn",
	"./chat_files/ppt.png": "EfVa",
	"./chat_files/rar.png": "aKCp",
	"./chat_files/txt.png": "3T2L",
	"./chat_files/xls.png": "uW39",
	"./chat_files/zip.png": "FW0E",
	"./dxb.png": "1fYO",
	"./fxng1.png": "POhS",
	"./gx.png": "ERRH",
	"./gywm1.png": "f87y",
	"./hdzq.png": "qCyG",
	"./hdzq1.png": "06PG",
	"./home_day1.png": "kFde",
	"./home_logo.gif": "uFPf",
	"./home_logo.png": "tESk",
	"./home_logo_old.png": "OK2H",
	"./home_month1.png": "UYj4",
	"./kx.png": "yGPf",
	"./label_sm_90030.png": "uo9O",
	"./like_h@2x.png": "tjFQ",
	"./like_n@2x.png": "2ZsX",
	"./line.png": "+r4D",
	"./login_logo.gif": "kuh2",
	"./login_logo.png": "ERDW",
	"./logo.gif": "IS4X",
	"./logo.png": "iQH9",
	"./mxpz.png": "0Uyq",
	"./new_download.png": "1FOx",
	"./ng_button.png": "RVGt",
	"./ngzg.png": "D5Jo",
	"./ngzg_new.png": "Ez8k",
	"./ngzg_new1.png": "Lb9N",
	"./nrng.png": "SKju",
	"./online.png": "vCSb",
	"./over.png": "cuPE",
	"./quotes_banner.png": "uQ59",
	"./recharge.jpg": "+PBw",
	"./rechargeicon.png": "Q5sm",
	"./sell@2x.png": "zeH3",
	"./shui.png": "M1t+",
	"./sound-muted.png": "+r6r",
	"./sound-on.png": "9dhs",
	"./sound.png": "U/et",
	"./systemImg.jpg": "wi2T",
	"./wcs.png": "+XIr",
	"./wpjm.png": "dQhx",
	"./zg_button.png": "AZz2",
	"./在线客服.png": "oCbS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 3